import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const SempDayForm = ({ show, onHide, onSave, day }) => {
    const initialFormData = {
        semp_seq_no: '',
        semp_year: new Date().getFullYear(),
        semp_day: '',
        semp_youtube: '',
        semp_subject: '',
        semp_date: '',
        semp_daytitle: '',
        semp_photo: '',
        semp_color: '#000000',
    };

    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        if (day) {
            setFormData(day);
        } else {
            setFormData(initialFormData);
        }
    }, [day, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{day ? '일정 수정' : '새 일정 추가'}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formSempDate">
                            <Form.Label>날짜</Form.Label>
                            <Form.Control type="date" name="semp_date" value={formData.semp_date} onChange={handleChange} required />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formSempDay">
                            <Form.Label>Day</Form.Label>
                            <Form.Control 
                                type="text" 
                                name="semp_day" 
                                value={formData.semp_day} 
                                onChange={handleChange} 
                                maxLength={10}
                                placeholder="10자 이내 입력"
                            />
                        </Form.Group>
                    </Row>

                    <Form.Group className="mb-3" controlId="formSempSubject">
                        <Form.Label>주제</Form.Label>
                        <Form.Control type="text" name="semp_subject" value={formData.semp_subject} onChange={handleChange} required />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formSempDayTitle">
                        <Form.Label>요일 제목</Form.Label>
                        <Form.Control type="text" name="semp_daytitle" value={formData.semp_daytitle} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formSempYoutube">
                        <Form.Label>유튜브 링크</Form.Label>
                        <Form.Control type="url" name="semp_youtube" value={formData.semp_youtube} onChange={handleChange} placeholder="https://youtube.com/..." />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formSempPhoto">
                        <Form.Label>사진 URL</Form.Label>
                        <Form.Control type="url" name="semp_photo" value={formData.semp_photo} onChange={handleChange} placeholder="https://example.com/image.jpg" />
                    </Form.Group>

                    <Row>
                        <Form.Group as={Col} controlId="formSempYear">
                            <Form.Label>연도</Form.Label>
                            <Form.Control type="number" name="semp_year" value={formData.semp_year} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formSempColor">
                            <Form.Label>색상</Form.Label>
                            <Form.Control type="color" name="semp_color" value={formData.semp_color} onChange={handleChange} />
                        </Form.Group>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>취소</Button>
                    <Button variant="primary" type="submit">저장</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default SempDayForm;
